import {
  GenericForm,
  GenericFormLogic,
  GenericFormLogicalField,
  GenericFormLogicalFieldPresentation,
  GenericFormValidationContext_forValidation,
  genericBeforeValidate_removeDefaultKeyedError,
  genericValidate_textField,
  ValidationEvent,
} from "../../hooks";

import { replaceAll } from "../../utils";

import { InitialStateMinimumRequirements_OneTimePassword_Form } from "./one-time-password-intitial-state";

export interface OneTimePasswordForm_VerifyCode extends GenericForm {
  oneTimePassword?: string;
}

export interface AppMinimumRequirementsForOneTimePasswordForm {
  initialState: InitialStateMinimumRequirements_OneTimePassword_Form;
}

export interface OneTimePasswordFormApp_VerifyCode
  extends AppMinimumRequirementsForOneTimePasswordForm {}

const oneTimePasswordFieldFormLogic = <
  Form extends GenericForm,
  App extends AppMinimumRequirementsForOneTimePasswordForm
>(
  props: GenericFormLogicalFieldPresentation = {}
): GenericFormLogicalField<Form, App> => ({
  presentation: props,
  validationEvents: [
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  cleanEvents: [
    ValidationEvent.onFocus,
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: (
    context: GenericFormValidationContext_forValidation<Form, App>
  ) => {
    genericValidate_textField<Form, App>({
      required: props.required,
      trim: true,
      maxLength: context.app.initialState.one_time_password?.length || 0,
      customLength: (value: any) => {
        const valueWithOnlyAllowedCharacters = replaceAll(
          value || "",
          "[^\\d]",
          ""
        );
        return {
          value: valueWithOnlyAllowedCharacters,
        };
      },
    })(context);
  },
});

export const OneTimePasswordFormLogic_VerifyCode: GenericFormLogic<
  OneTimePasswordForm_VerifyCode,
  OneTimePasswordFormApp_VerifyCode
> = {
  oneTimePassword: oneTimePasswordFieldFormLogic({ required: true }),
} as const;

export const OneTimePasswordFormInitialState_VerifyCode =
  (): OneTimePasswordForm_VerifyCode => ({});
